import { PATHS } from 'utils/paths'

/** Routes that must work without a valid session (previews, public package links, auth pages). */
export function isPublicAppRoute(pathname: string): boolean {
  const path = pathname.toLowerCase()

  if (
    path === PATHS.home ||
    path === PATHS.login ||
    path === PATHS.resetPassword ||
    path === PATHS.setPassword ||
    path === PATHS.privacyPolicy ||
    path === PATHS.cardPreview.toLowerCase() ||
    path === PATHS.landingPagePreview.toLowerCase() ||
    path === PATHS.reviewAccess.toLowerCase() ||
    /^\/review\/sessions\/[^/]+$/.test(path) ||
    path === PATHS.notFoundPage.toLowerCase()
  ) {
    return true
  }

  if (PATHS.christmasCards.some(card => card.toLowerCase() === path)) {
    return true
  }

  if (/^\/iframe\/.+/.test(path)) {
    return true
  }

  // `/packages` is the authenticated list; `/packages/:token` is the public share link.
  if (/^\/packages\/.+/.test(path)) {
    return true
  }

  return false
}
